import React from "react";
import styled from "styled-components";
import { media } from "../theme";
import { useMedia } from "react-use";

const Wrapper = styled.div`
  width: 70%;
  height: 300px;
`;

const GenericError = () => {
  const isDesktop = useMedia(media.lg);
  return (
    <Wrapper>
      <img
        className={"w-100 h-100"}
        src={
          isDesktop
            ? "allodedidcace_erreur_500_desktop.png"
            : "/allodedidcace_erreur_500_mobile.png"
        }
        alt="comming soon image"
      />
    </Wrapper>
  );
};

export default GenericError;
